const TERMS_CDN_URL = 'https://assets-pid-cdn.pinkfong.com/static/i18n.json';
const terms: Record<string, Record<string, string>> = {
  privacyPolicy: { ko: '', en: '', es: '', id: '', zh: '', ja: '', pt: '' },
  termsOfInteractiveApp: { ko: '', en: '', es: '', id: '', zh: '', ja: '', pt: '' },
  termsOfService: { ko: '', en: '', es: '', id: '', zh: '', ja: '', pt: '' },
};

export async function loadTermsAndPolicies(): Promise<void> {
  const response = await fetch(TERMS_CDN_URL, {
    method: 'GET',
    cache: 'force-cache',
  });
  const data = await response.json();

  for (const i18nValue of data) {
    switch (i18nValue.key) {
      case 'HTML.TERMS_AND_CONDITIONS': {
        terms.termsOfService = {
          ko: i18nValue.ko,
          en: i18nValue.en,
          es: i18nValue.es,
          id: i18nValue.in,
          zh: i18nValue.zh,
          ja: i18nValue.ja,
          pt: i18nValue.pt,
        };
        break;
      }
      case 'HTML.PRIVACY_POLICY': {
        terms.privacyPolicy = {
          ko: i18nValue.ko,
          en: i18nValue.en,
          es: i18nValue.es,
          id: i18nValue.in,
          zh: i18nValue.zh,
          ja: i18nValue.ja,
          pt: i18nValue.pt,
        };
        break;
      }
      case 'HTML.INTERACTIVE_TERMS_AND_CONDITIONS': {
        terms.termsOfInteractiveApp = {
          ko: i18nValue.ko,
          en: i18nValue.en,
          es: i18nValue.es,
          id: i18nValue.in,
          zh: i18nValue.zh,
          ja: i18nValue.ja,
          pt: i18nValue.pt,
        };
        break;
      }
    }
  }
}

export function getPrivacyPolicy(language: string): string {
  return terms.privacyPolicy[language] || terms.privacyPolicy.en || '';
}

export function getTermsOfInteractiveApp(language: string): string {
  return terms.termsOfInteractiveApp[language] || terms.termsOfInteractiveApp.en || '';
}

export function getTermsOfService(language: string): string {
  return terms.termsOfService[language] || terms.termsOfService.en || '';
}
